import React from 'react';
import styles from './TeamLead.module.scss';
import { FiltersKeys, ISelectedFilters } from './interface';
import cx from 'classnames';

interface ITeamLeadRenderFiltersProps {
  handleFilterSelection: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  selectedFilters: ISelectedFilters;
  activeFilters: string;
}

export const TeamLeadRenderFilters: React.FC<ITeamLeadRenderFiltersProps> = props => {
  const { handleFilterSelection, selectedFilters, activeFilters } = props;
  return (
    <>
      {FiltersKeys.map(filter => {
        const { key, label } = filter;
        const selectionCount = Object.keys(
          selectedFilters?.[key as keyof typeof selectedFilters] ?? {}
        ).length;
        return (
          <div
            id={key}
            onClick={handleFilterSelection}
            key={key}
            className={styles.filterCountContainer}
          >
            <div
              className={cx(styles.filterSection, {
                [styles.selectedFilter]: key === activeFilters
              })}
            >
              {label + ' '}
            </div>
            {selectionCount > 0 && <span className={styles.count}>{selectionCount}</span>}
          </div>
        );
      })}
    </>
  );
};
